export enum PlatformType {
  desktop = 'desktop',
  mobile = 'mobile',
}
